<template>
  <footer class="footer-static" v-if="showTrustpilot">
    <div class="container mx-auto">
      <div
          ref="trustpilot"
          class="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="5f05940d51095100018ac47e"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
          data-review-languages="en"
          data-text-color="#28526F"
          data-font-family="Source Sans Pro"
      >
        <a
            href="https://uk.trustpilot.com/review/ascenti.co.uk"
            target="_blank"
            rel="noopener"
        >Trustpilot</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      showTrustpilot: process.env.VUE_APP_SHOW_TRUSTPILOT === 'true',
    };
  },

  mounted() {
    if (!this.showTrustpilot) return;

    this.injectTrustpilotScript().then(() => {
      let attempts = 10;
      const tryLoad = () => {
        const widget = this.$refs.trustpilot;
        if (window.Trustpilot && widget && widget.getAttribute('data-template-id')) {
          window.Trustpilot.loadFromElement(widget, true);
        } else if (attempts-- > 0) {
          setTimeout(tryLoad, 200);
        } else {
          console.warn('Trustpilot widget failed to load after multiple attempts');
        }
      };
      tryLoad();
    });
  },

  methods: {
    injectTrustpilotScript() {
      return new Promise((resolve) => {
        if (window.Trustpilot) return resolve();

        const existing = document.querySelector('script[src*="tp.widget.bootstrap.min.js"]');
        if (existing) {
          existing.addEventListener('load', () => resolve());
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    },
  },
};
</script>

<style scoped>
.footer-static {
  background-color: #D0DEE5;
  padding: 50px 0;
}
</style>
